import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { marker } from "@jsverse/transloco-keys-manager/marker";
import { Observable } from "rxjs";
import { UserNotify } from "src/app/support/notify-decorator";
import { environment } from "src/environments/environment";
import {
  PrefixDiagnosticModel,
  PrefixDirectoryModel
} from "../models/configuration/prefix";

@Injectable()
export class PrefixBackend {
  constructor(private http: HttpClient) {}

  loadDirectoryPrefix(): Observable<PrefixDirectoryModel> {
    const prefix = this.http.get<PrefixDirectoryModel>(
      `${environment.snoots.api.directory}/prefixes`
    );
    return prefix;
  }

  @UserNotify({
    successMessage: marker("Update prefix"),
    errorMessage: marker("Non è stato possibile aggiornare il prefix")
  })
  updateDirectoryPrefix(
    id: string,
    patient?: string,
    customer?: string
  ): Observable<PrefixDirectoryModel> {
    return this.http.patch<PrefixDirectoryModel>(
      `${environment.snoots.api.directory}/prefixes/${id}`,
      {
        patient,
        customer
      }
    );
  }

  loadDiagnosticPrefix(): Observable<PrefixDiagnosticModel> {
    const prefix = this.http.get<any>(
      `${environment.snoots.api.diagnostic}/prefixes`
    );
    return prefix;
  }

  @UserNotify({
    successMessage: marker("Update prefix"),
    errorMessage: marker("Non è stato possibile aggiornare il prefix")
  })
  updateDiagnosticPrefix(
    id: string,
    request?: string,
    study?: string,
    worklist?: string
  ): Observable<PrefixDiagnosticModel> {
    return this.http.patch<PrefixDiagnosticModel>(
      `${environment.snoots.api.diagnostic}/prefixes/${id}`,
      {
        request,
        study,
        worklist
      }
    );
  }
}
